import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IntegrationsService } from '../../../core/services/integrations.service';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { NotificationService } from '../../../core/services/notification.service';
import { AuthProvider } from '../../models/integrations.model';
import { LoggedUserReport } from '../../models/user';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-auth-basic-modal',
  templateUrl: './auth-basic-modal.component.html',
  styleUrls: ['./auth-basic-modal.component.less']
})
export class AuthBasicModalComponent implements OnInit {
  dataSourceProvider: AuthProvider | null = null;
  report: LoggedUserReport | null = null;
  credentialsConfiguredCallback?: () => void;
  
  @ViewChild('tooltipTemplate') tooltipTemplate!: TemplateRef<any>;
  
  authForm!: FormGroup;
  isSubmittingCredentials: boolean = false;

  constructor(
    private modalRef: NzModalRef,
    private fb: FormBuilder,
    private integrationsService: IntegrationsService,
    private authService: AuthenticationService,
    private notificationService: NotificationService
  ) {
    // Obtener parámetros del modal
    this.dataSourceProvider = this.modalRef.getConfig().nzData?.dataSourceProvider;
    this.report = this.modalRef.getConfig().nzData?.report;
    this.credentialsConfiguredCallback = this.modalRef.getConfig().nzData?.onCredentialsConfigured;
  }

  ngOnInit(): void {
    this.initializeAuthForm();
  }

  private initializeAuthForm(): void {
    this.authForm = this.fb.group({
      login: ['', Validators.required],
      apiKey: ['', Validators.required]
    });
  }

  async onSubmitCredentials(): Promise<void> {
    if (this.authForm.invalid || !this.dataSourceProvider) return;

    this.isSubmittingCredentials = true;

    const credentialsData = {
      ownerId: this.authService.loggedUser$.value?.userId || 0,
      dataSourceProviderId: this.dataSourceProvider.id,
      payload: {
        login: this.authForm.value.login,
        apiKey: this.authForm.value.apiKey
      },
      authorized: true,
      authorizedAt: new Date().toISOString()
    };

    try {
      await this.integrationsService.createCredentials(credentialsData).toPromise();

      // Verificar si las credenciales quedaron válidas para este DataSourceProvider
      const verifyResp = await this.integrationsService
        .checkCredentialsStatus(this.dataSourceProvider.id)
        .toPromise();

      if (verifyResp && verifyResp.isValid) {
        this.notificationService.success('Éxito', 'Credenciales configuradas correctamente');
        // Ejecutar callback si existe
        if (this.credentialsConfiguredCallback) {
          this.credentialsConfiguredCallback();
        }
        // Cerrar modal
        this.modalRef.close();
      } else {
        this.notificationService.error('Credenciales inválidas', 'Las credenciales no son válidas para esta integración. Verifica e inténtalo nuevamente.');
      }
    } catch (error) {
      this.notificationService.error('Error', 'No se pudieron configurar las credenciales. Inténtalo de nuevo.');
    } finally {
      this.isSubmittingCredentials = false;
    }
  }

  closeModal(): void {
    this.modalRef.close();
  }

  get reportName(): string {
    return this.report?.name || 'este reporte';
  }

  get dataSourceProviderName(): string {
    return this.dataSourceProvider?.name || 'el proveedor de datos';
  }
}

